var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style),attrs:{"id":"loading"}},[_c('div',{attrs:{"id":"loading-center"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }